import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PortalReportsPage } from "@/features/portal/PortalReportsPage";

const search = z.object({
  report: z.string().optional(),
});

/** Portal reports (P109, P1-PORTAL-SHELL): the shared status updates. `report` in the address opens one of them. */
export const Route = createFileRoute("/portal/reports")({
  validateSearch: search,
  component: () => <PortalReportsPage selectedId={Route.useSearch().report} />,
});
